exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".breadcrumb[_v-4927628e]{text-align:left;font-size:9px}.breadcrumb>li+li[_v-4927628e]:before{content:\">\";color:#000}.breadcrumb li[_v-4927628e]{padding-right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-4927628e&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/Admin/Breadcrumb-product.vue
// module id = 429
// module chunks = 0